define(function(require) {
    'use strict';
    var _ = require('underscore');
    var AppConfig = require('config/application');
    var Backbone = require('backbone');

    return Backbone.Model.extend({
        urlRoot: AppConfig.host + '/rest/domains',
        initialize: function() {
            this.on('change:domain', this.changeDomain, this);
        },
        parse: function (data, options) {
            if (_.isObject(data.result)) {
                return data.result;
            } else {
                return data;
            }
        },
        checkStatus: function() {
            return Backbone.ajax({
                type: 'PUT',
                url: this.urlRoot + '/' + this.id + '/verify'
            })
        },

        getStatus: function() {
            var status = 'unknown';
            var blocked = this.get('blocked');
            var verified = this.get('verified');
            if (blocked) {
                status = 'blocked';
            } else if (verified) {
                status = 'active';
            } else if (!verified) {
                status = 'on_validate';
            }
            return status;
        },

        changeDomain: function(model, value) {
            var domain = value.toLowerCase();
            domain = domain.replace(new RegExp('[^a-z0-9.-]','g'),'');
            if(domain != value) {
                this.set('domain', domain);
            }
        },

        validate: function(attrs, options) {
            var errors = [];
            if(!attrs.domain || attrs.domain.length < 2) {
                errors.push({
                    field: 'domain',
                    message: 'Необходимо ввести название домена!'
                });
            }

            if(!attrs.site_id) {
                errors.push({
                    field: 'site_id',
                    message: 'Необходимо выбрать проект!'
                });
            }
            return errors.length && errors;
        }
    })
});